export default "__VITE_ASSET__$51EGjTT__"